export default (state={}, action) =>{
    switch(action.type)
    {
        case 'SET_STATE_COLLAPSE_MENU_PEST2':
            return action.payload;
        default: return state;
    }
}